import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { Eyebrow, Reveal } from "@/components/site/Reveal";
import { useLang, scrollToId } from "@/i18n";

const Block = ({ b }) => {
  if (typeof b === "string") return <p className="text-zinc-300 leading-relaxed">{b}</p>;
  return (
    <ul className="space-y-2.5">
      {b.list.map((li) => (
        <li key={li} className="flex gap-3 text-zinc-300 leading-relaxed"><span className="mt-2.5 h-1.5 w-1.5 shrink-0 bg-red-600" />{li}</li>
      ))}
    </ul>
  );
};

export default function LegalPage({ doc }) {
  const { t, lang } = useLang();
  return (
    <div className="min-h-screen bg-[#050505] text-white" data-testid={`legal-page-${doc.slug}`}>
      <Nav />
      <main className="relative pt-36 pb-28">
        <div className="absolute inset-x-0 top-0 h-[520px] tac-grid" />
        <div className="relative max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12">
          <Reveal>
            <Eyebrow>Legal · ARMAT DEFENSE S.R.L.</Eyebrow>
            <h1 className="mt-6 font-display font-black uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.92] max-w-4xl" data-testid="legal-page-title">{doc.title}</h1>
            <p className="mt-6 font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">{t.legal.updated}: {doc.updated}</p>
            {lang === "en" && <p className="mt-3 text-sm text-zinc-400">{t.legal.onlyRo}</p>}
          </Reveal>
          <div className="mt-16 grid lg:grid-cols-12 gap-12">
            <aside className="hidden lg:block lg:col-span-3">
              <nav className="sticky top-28 border-l border-white/10 pl-5 space-y-2.5" data-testid="legal-toc">
                <p className="font-mono text-xs uppercase tracking-[0.25em] text-red-500 mb-4">{t.legal.toc}</p>
                {doc.sections.map((s, i) => (
                  <button key={s.h} onClick={() => scrollToId(`sec-${i}`)} className="block text-left text-sm text-zinc-400 hover:text-white transition-colors">{i + 1}. {s.h}</button>
                ))}
              </nav>
            </aside>
            <article className="lg:col-span-8 max-w-3xl space-y-12">
              {doc.intro && <p className="text-lg text-zinc-200 leading-relaxed">{doc.intro}</p>}
              {doc.sections.map((s, i) => (
                <section key={s.h} id={`sec-${i}`} className="scroll-mt-28">
                  <h2 className="font-display font-bold uppercase text-2xl sm:text-3xl text-white"><span className="font-mono text-sm text-red-500 mr-3 align-middle">{String(i + 1).padStart(2, "0")}</span>{s.h}</h2>
                  <div className="mt-5 space-y-4">{s.body.map((b, j) => <Block key={j} b={b} />)}</div>
                </section>
              ))}
              <Link to="/" data-testid="legal-back-link" className="clip-btn inline-flex items-center gap-2 border border-white/20 hover:border-red-500 transition-colors px-6 py-4 font-mono text-xs uppercase tracking-[0.18em]"><ArrowLeft className="h-4 w-4" />{t.legal.back}</Link>
            </article>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
